export const getCountryName = ( countryName, countryNameOtherLanguages, soLanguageCultureCode ) => { 
  // Parse JSON string into an object if it's not already
  const parsed = countryNameOtherLanguages && typeof countryNameOtherLanguages === "string" ? JSON.parse(countryNameOtherLanguages) : countryNameOtherLanguages;
  const response = parsed?.[soLanguageCultureCode] || countryName;
  return response;
};